import { useTranslation } from '@shared/localization';

import { ArrowIcon, SimpleButton } from '@/components/common';
import PaymentStore from '@/services/payments/PaymentStore';
import { redirect } from '@/utils/redirect';

export function RedirectUrlButton() {
  const { t } = useTranslation();
  const redirectUrl = PaymentStore.redirectUrl;

  if (!redirectUrl) {
    return null;
  }

  return (
    <SimpleButton onClick={() => redirect(redirectUrl)}>
      <span className={'flex flex-row items-center justify-center'}>
        <ArrowIcon direction="left" />
        <span className={'ml-xs'}>{t('Back')}</span>
      </span>
    </SimpleButton>
  );
}
